module.exports = __webpack_public_path__ + "static/media/no-image.5183c9fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-image.png
// module id = 1024
// module chunks = 0